import { requestURL, requestWithToken } from '../utilities/request';
import { API } from '../utilities/constants';

const resetPassword = (options, params, apiPath) => {
  return requestURL({
    ...options,
    method: 'POST',
    data: params,
    url: `${API.endpoint}/${apiPath}`,
  });
};

const getUnableResetPasswordUsers = options => {
  return requestURL({
    ...options,
    method: 'GET',
    url: `${API.endpoint}/api/private/users/not_reset_password_foreman_users`,
    dataType: 'json',
  });
};

const getPasswordPolicy = userRoleCode => {
  return requestWithToken({
    method: 'GET',
    params: {
      user_role_code: userRoleCode,
      system_id: 1, // 調整会議
    },
    url: '/api/private/users/password_policies',
  });
};

export const PasswordPolicyService = {
  resetPassword,
  getUnableResetPasswordUsers,
  getPasswordPolicy,
};



// WEBPACK FOOTER //
// ./src/services/PasswordPolicyService.js